import { useMutation } from "@tanstack/react-query";
import { createPerformanceApi } from "@/API/createPerformanceApi";
import { ShowNotification } from "@/components/ShowNotification";
import { useErrorBoundary } from "@/hooks/helperHooks/useErrorBoundary";
import { useInvalidateQueries } from "@/hooks/helperHooks/useInvalidateQueries";

export const useCreatePerformance = () => {
  const handleError = useErrorBoundary();
  const { invalidateStudies } = useInvalidateQueries();
  return useMutation<any, Error, any>({
    mutationFn: (performanceCalculationInput) =>
      createPerformanceApi(performanceCalculationInput),
    onSuccess: () => {
      invalidateStudies();
      ShowNotification({
        title: "Request Sent",
        message: "Your performance calculation request has been sent.",
        color: "success",
      });
    },
    onError: (error: Error) => {
      ShowNotification({
        title: "Error",
        message: "There was an error sending your request.",
        color: "error",
      });
      handleError(error);
    },
  });
};
